import React from 'react';
import bannerBg from '../../images/division_hero_bg.png';

function BannerPageTitle({ title, subtitle }) {
    return (
        <div> 
            <div style={{ 
                position: 'relative',
                width: '100%',
                minHeight: '220px',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                backgroundImage: `url(${bannerBg})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                borderBottom: '4px solid var(--yellow)'
            }}>
                {/* Dark Blue Overlay with glassmorphism to let image peek through */}
                <div style={{
                    position: 'absolute',
                    top: 0, left: 0, right: 0, bottom: 0,
                    background: 'linear-gradient(135deg, rgba(6,13,138,0.85) 0%, rgba(4,9,96,0.95) 100%)',
                    zIndex: 1
                }}></div>

                {/* Content */}
                <div style={{
                    position: 'relative',
                    zIndex: 2,
                    textAlign: 'center',
                    padding: '0 20px',
                    maxWidth: 'var(--maxWidth)',
                    width: '100%',
                    animation: 'fadeInUp 0.6s ease-out forwards'
                }}>
                    <h1 style={{
                        fontFamily: 'var(--fontDisplay), "Oswald", sans-serif',
                        fontSize: 'clamp(2rem, 5vw, 3.5rem)',
                        fontWeight: 700,
                        color: '#ffffff',
                        margin: '0',
                        textTransform: 'uppercase',
                        letterSpacing: '1px',
                        textShadow: '0 2px 10px rgba(0,0,0,0.5)'
                    }}>
                        {title}
                    </h1>
                    {subtitle && (
                        <p style={{
                            fontFamily: 'var(--fontBody), "Inter", sans-serif',
                            color: '#e0e0e0',
                            fontSize: '1.1rem',
                            marginTop: '10px',
                            fontWeight: 500,
                            maxWidth: '600px',
                            margin: '10px auto 0 auto'
                        }}>
                            {subtitle}
                        </p>
                    )}
                </div>
            </div>

            {/* Global Keyframes for subtle animations */}
            <style dangerouslySetInnerHTML={{__html: `
                @keyframes fadeInUp {
                    from { opacity: 0; transform: translateY(20px); }
                    to { opacity: 1; transform: translateY(0); }
                }
            `}} />
        </div>
    );
}

export default BannerPageTitle;
